import { HR_HOME_TAB } from 'config/hrMenuConfig';

/** 업무 화면 탭 상한 — 환경설정에서 숫자를 바꾸지 않음 */
export const WORKSPACE_TAB_MAX = 10;

export const TAB_DASHBOARD_MODE = {
  EXCLUDE: 'exclude',
  INCLUDE: 'include',
};

export const TAB_CLOSE_MSG_MODE = {
  FACT: 'fact',
  REASON: 'reason',
  SHORT: 'short',
  CUSTOM: 'custom',
};

/** 워크스페이스 상단 탭 바 표시 — 기본은 기존 라벨형 */
export const TAB_DISPLAY_MODE = {
  LABEL: 'label',
  COMPACT: 'compact',
};

export const TAB_CLOSE_MSG_PRESETS = {
  [TAB_CLOSE_MSG_MODE.FACT]:
    '탭은 최대 10개입니다. 「{닫힌화면}」을 닫고 「{새화면}」을 열었습니다.',
  [TAB_CLOSE_MSG_MODE.REASON]:
    '화면은 최대 10개까지 열 수 있습니다. 탭이 많으면 속도에 영향을 주어 「{닫힌화면}」을 닫았습니다.',
  [TAB_CLOSE_MSG_MODE.SHORT]: '「{닫힌화면}」을 닫고 새 화면을 열었습니다.',
};

export const TAB_DASHBOARD_MODE_OPTIONS = [
  { value: TAB_DASHBOARD_MODE.EXCLUDE, label: '대시보드 빼고 10개' },
  { value: TAB_DASHBOARD_MODE.INCLUDE, label: '대시보드 포함 10개' },
];

export const TAB_CLOSE_MSG_MODE_OPTIONS = [
  { value: TAB_CLOSE_MSG_MODE.FACT, label: '1안 — 사실만' },
  { value: TAB_CLOSE_MSG_MODE.REASON, label: '2안 — 이유 포함' },
  { value: TAB_CLOSE_MSG_MODE.SHORT, label: '3안 — 짧게' },
  { value: TAB_CLOSE_MSG_MODE.CUSTOM, label: '4안 — 직접입력' },
];

export const TAB_DISPLAY_MODE_OPTIONS = [
  { value: TAB_DISPLAY_MODE.LABEL, label: '라벨형 (기존)' },
  { value: TAB_DISPLAY_MODE.COMPACT, label: '컴팩트 호버형' },
];

export function defaultWorkspaceTabSettings() {
  return {
    includeDashboard: TAB_DASHBOARD_MODE.EXCLUDE,
    closeMsgMode: TAB_CLOSE_MSG_MODE.FACT,
    closeMsgCustom: '',
    displayMode: TAB_DISPLAY_MODE.LABEL,
  };
}

export function normalizeWorkspaceTabSettings(raw = {}) {
  const defaults = defaultWorkspaceTabSettings();
  const mode = String(raw.closeMsgMode || '');
  const displayMode = String(raw.displayMode || '');
  return {
    includeDashboard:
      raw.includeDashboard === TAB_DASHBOARD_MODE.INCLUDE
        ? TAB_DASHBOARD_MODE.INCLUDE
        : defaults.includeDashboard,
    closeMsgMode: Object.values(TAB_CLOSE_MSG_MODE).includes(mode)
      ? mode
      : defaults.closeMsgMode,
    closeMsgCustom: String(raw.closeMsgCustom || ''),
    displayMode: Object.values(TAB_DISPLAY_MODE).includes(displayMode)
      ? displayMode
      : defaults.displayMode,
  };
}

function applyPlaceholders(tpl, closedLabel, newLabel) {
  return String(tpl || '')
    .split('{닫힌화면}')
    .join(closedLabel || '')
    .split('{새화면}')
    .join(newLabel || '');
}

export function resolveTabCloseMessageTemplate(settings) {
  const s = normalizeWorkspaceTabSettings(settings);
  if (s.closeMsgMode === TAB_CLOSE_MSG_MODE.CUSTOM) {
    return String(s.closeMsgCustom || '').trim();
  }
  return TAB_CLOSE_MSG_PRESETS[s.closeMsgMode] || TAB_CLOSE_MSG_PRESETS[TAB_CLOSE_MSG_MODE.FACT];
}

export function formatTabCloseMessage(settings, closedLabel, newLabel) {
  const tpl = resolveTabCloseMessageTemplate(settings);
  if (!tpl) return '';
  return applyPlaceholders(tpl, closedLabel, newLabel);
}

/** 환경설정 미리보기용 */
export function previewTabCloseMessage(settings) {
  const msg = formatTabCloseMessage(settings, '발령 목록', '인사마스터');
  if (msg) return msg;
  if (normalizeWorkspaceTabSettings(settings).closeMsgMode === TAB_CLOSE_MSG_MODE.CUSTOM) {
    return '비우면 안내를 띄우지 않습니다.';
  }
  return '';
}

function isHomeTab(tab, homeId) {
  return tab && String(tab.id) === String(homeId);
}

/**
 * 이미 열린 탭이 아닐 때 상한을 넘으면 가장 오래된 업무 탭을 닫는다.
 * 대시보드(홈)는 자동으로 닫지 않는다.
 */
export function applyWorkspaceTabOpenLimit(
  prevTabs,
  tabData,
  settings,
  homeId = HR_HOME_TAB.id
) {
  const s = normalizeWorkspaceTabSettings(settings);
  const list = Array.isArray(prevTabs) ? prevTabs : [];
  const newTabIsHome = isHomeTab(tabData, homeId);
  const workCount = list.filter((t) => !isHomeTab(t, homeId)).length;
  const counted =
    s.includeDashboard === TAB_DASHBOARD_MODE.INCLUDE ? list.length : workCount;
  const newCounts =
    s.includeDashboard === TAB_DASHBOARD_MODE.INCLUDE || !newTabIsHome;

  if (!newCounts || counted < WORKSPACE_TAB_MAX) {
    return { tabs: list, closedTab: null };
  }

  const idx = list.findIndex((t) => !isHomeTab(t, homeId));
  if (idx < 0) {
    return { tabs: list, closedTab: null };
  }

  return {
    tabs: list.filter((_, i) => i !== idx),
    closedTab: list[idx],
  };
}
